var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Loyalty = (function (Loyalty) {

        Loyalty.Messages = (function (Messages) {

            Messages.GetLoyaltyNewsDetail = function (newsId) {
                var data = {
                    newsId: newsId
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetLoyaltyNewsDetail', data);
            };
            Messages.GetLoyaltyNewsDetail.className = 'Vendd.Loyalty.Messages.GetLoyaltyNewsDetail';

            Messages.GetLoyaltyNewsDetailSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetLoyaltyNewsDetailSuccess', response);
            };
            Messages.GetLoyaltyNewsDetailSuccess.className = 'Vendd.Loyalty.Messages.GetLoyaltyNewsDetailSuccess';

            Messages.GetLoyaltyNewsDetailFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetLoyaltyNewsDetailFailure', response);
            };
            Messages.GetLoyaltyNewsDetailFailure.className = 'Vendd.Loyalty.Messages.GetLoyaltyNewsDetailFailure';

            Messages.CheckByMobile = function (mobile) {
                var data = {
                    mobile: mobile
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.CheckByMobile', data);
            };
            Messages.CheckByMobile.className = 'Vendd.Loyalty.Messages.CheckByMobile';

            Messages.CheckByMobileSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.CheckByMobileSuccess', response);
            };
            Messages.CheckByMobileSuccess.className = 'Vendd.Loyalty.Messages.CheckByMobileSuccess';

            Messages.CheckByMobileFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.CheckByMobileFailure', response);
            };
            Messages.CheckByMobileFailure.className = 'Vendd.Loyalty.Messages.CheckByMobileFailure';

            Messages.SendSms = function (mobile, reCaptchaCode) {
                var data = {
                    mobile: mobile,
                    reCaptchaCode: reCaptchaCode
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SendSms', data);
            };
            Messages.SendSms.className = 'Vendd.Loyalty.Messages.SendSms';

            Messages.SendSmsSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SendSmsSuccess', response);
            };
            Messages.SendSmsSuccess.className = 'Vendd.Loyalty.Messages.SendSmsSuccess';

            Messages.SendSmsFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SendSmsFailure', response);
            };
            Messages.SendSmsFailure.className = 'Vendd.Loyalty.Messages.SendSmsFailure';
            

            Messages.ValidateSmsCode = function (mobile, code) {
                var data = {
                    mobile: mobile,
                    code: code
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ValidateSmsCode', data);
            };
            Messages.ValidateSmsCode.className = 'Vendd.Loyalty.Messages.ValidateSmsCode';

            Messages.ValidateSmsCodeSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ValidateSmsCodeSuccess', response);
            };
            Messages.ValidateSmsCodeSuccess.className = 'Vendd.Loyalty.Messages.ValidateSmsCodeSuccess';

            Messages.ValidateSmsCodeFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ValidateSmsCodeFailure', response);
            };
            Messages.ValidateSmsCodeFailure.className = 'Vendd.Loyalty.Messages.ValidateSmsCodeFailure';


            Messages.SubmitForm = function (formData) {              
                var data = formData;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitForm', data);
            };
            Messages.SubmitForm.className = 'Vendd.Loyalty.Messages.SubmitForm';

            Messages.SubmitFormSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitFormSuccess', response);
            };
            Messages.SubmitFormSuccess.className = 'Vendd.Loyalty.Messages.SubmitFormSuccess';

            Messages.SubmitFormFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitFormFailure', response);
            };
            Messages.SubmitFormFailure.className = 'Vendd.Loyalty.Messages.SubmitFormFailure';

            Messages.SubmitSfmForm = function (registrationFormData) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitSfmForm', registrationFormData);
            };
            Messages.SubmitSfmForm.className = 'Vendd.Loyalty.Messages.SubmitSfmForm';

            Messages.SubmitSfmFormSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitSfmFormSuccess', response);
            };
            Messages.SubmitSfmFormSuccess.className = 'Vendd.Loyalty.Messages.SubmitSfmFormSuccess';

            Messages.SubmitSfmFormFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitSfmFormFailure', response);
            };
            Messages.SubmitSfmFormFailure.className = 'Vendd.Loyalty.Messages.SubmitSfmFormFailure';

            Messages.GetPhoneForm = function (pageid) {
                var data = {
                    pageid: pageid
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetPhoneForm', data);
            };
            Messages.GetPhoneForm.className = 'Vendd.Loyalty.Messages.GetPhoneForm';

            Messages.GetPhoneFormSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetPhoneFormSuccess', response);
            };
            Messages.GetPhoneFormSuccess.className = 'Vendd.Loyalty.Messages.GetPhoneFormSuccess';

            Messages.GetPhoneFormFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetPhoneFormFailure', response);
            };
            Messages.GetPhoneFormFailure.className = 'Vendd.Loyalty.Messages.GetPhoneFormFailure';


            Messages.GetRegistrationForm = function (registered) {
                var data = {
                    registered: registered
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetRegistrationForm', data);
            };
            Messages.GetRegistrationForm.className = 'Vendd.Loyalty.Messages.GetRegistrationForm';

            Messages.GetRegistrationFormSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetRegistrationFormSuccess', response);
            };
            Messages.GetRegistrationFormSuccess.className = 'Vendd.Loyalty.Messages.GetRegistrationFormSuccess';

            Messages.GetRegistrationFormFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.GetRegistrationFormFailure', response);
            };
            Messages.GetRegistrationFormFailure.className = 'Vendd.Loyalty.Messages.GetRegistrationFormFailure';


            Messages.SubmitContactForm = function (formData) {
                var data = formData;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitContactForm', data);
            };
            Messages.SubmitContactForm.className = 'Vendd.Loyalty.Messages.SubmitContactForm';

            Messages.SubmitContactFormSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitContactFormSuccess', response);
            };
            Messages.SubmitContactFormSuccess.className = 'Vendd.Loyalty.Messages.SubmitContactFormSuccess';

            Messages.SubmitContactFormFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.SubmitContactFormFailure', response);
            };
            Messages.SubmitContactFormFailure.className = 'Vendd.Loyalty.Messages.SubmitContactFormFailure';


            Messages.ValidateCouponAndSendSms = function (discountCode) {
                var data = {
                    discountCode: discountCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ValidateCouponAndSendSms', data);
            };
            Messages.ValidateCouponAndSendSms.className = 'Vendd.Loyalty.Messages.ValidateCouponAndSendSms';


            Messages.ApplyCoupon = function (discountCode) {
                var data = {
                    discountCode: discountCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ApplyCoupon', data);
            };
            Messages.ApplyCoupon.className = 'Vendd.Loyalty.Messages.ApplyCoupon';

            Messages.ApplyCouponSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ApplyCouponSuccess', response);
            };
            Messages.ApplyCouponSuccess.className = 'Vendd.Loyalty.Messages.ApplyCouponSuccess';

            Messages.ApplyCouponFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ApplyCouponFailure', response);
            };
            Messages.ApplyCouponFailure.className = 'Vendd.Loyalty.Messages.ApplyCouponFailure';


            Messages.ClearCoupon = function (discountCode) {
                var data = {
                    discountCode: discountCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ClearCoupon', data);
            };
            Messages.ClearCoupon.className = 'Vendd.Loyalty.Messages.ClearCoupon';

            Messages.ClearCouponSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ClearCouponSuccess', response);
            };
            Messages.ClearCouponSuccess.className = 'Vendd.Loyalty.Messages.ClearCouponSuccess';

            Messages.ClearCouponFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.ClearCouponFailure', response);
            };
            Messages.ClearCouponFailure.className = 'Vendd.Loyalty.Messages.ClearCouponFailure';


            Messages.InviteFriends = function (formData) {
                var data = formData;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.InviteFriends', data);
            };
            Messages.InviteFriends.className = 'Vendd.Loyalty.Messages.InviteFriends';

            Messages.InviteFriendsSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.InviteFriendsSuccess', response);
            };
            Messages.InviteFriendsSuccess.className = 'Vendd.Loyalty.Messages.InviteFriendsSuccess';

            Messages.InviteFriendsFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Loyalty.Messages.InviteFriendsFailure', response);
            };
            Messages.InviteFriendsFailure.className = 'Vendd.Loyalty.Messages.InviteFriendsFailure';

            return Messages;

        })(Loyalty.Messages || {});

        return Loyalty;

    })(Vendd.Loyalty || {});

    return Vendd;

})(Vendd || {});